webpackJsonp([81926431289499],{

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Components = __webpack_require__(112);
	
	var _Components2 = _interopRequireDefault(_Components);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Components2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Field'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Component to...'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Changes...'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Doesn\'t reduce lines of code by much, by removes some boilerplate that could to easy copy/paste errors, and risk of typos leading to bad code (e.g. "errors[\'text\'] vs field.error).'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'import Field from lore-react-forms'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Remove touched from state, along with onBlur callback'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Can reference field.error instead of'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Before...'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import createReactClass from \'create-react-class\';\n      import PropTypes from \'prop-types\';\n      import _ from \'lodash\';\n\n      export default createReactClass({\n        displayName: \'FieldExample\',\n\n        getInitialState() {\n          return {\n            data: {\n              text: \'\'\n            },\n            touched: {\n              text: false\n            }\n          };\n        },\n\n        onChange(name, value) {\n          const nextData = _.merge({}, this.state.data);\n          nextData[name] = value;\n          this.setState({\n            data: nextData\n          });\n        },\n\n        getValidators: function(data) {\n          return {\n            text: [function(value) {\n              if (!value) {\n                return \'This field is required\';\n              }\n            }]\n          };\n        },\n\n        getErrors: function(validatorDictionary, data) {\n          return _.mapValues(data, function(value, key) {\n            const validators = validatorDictionary[key];\n            let error = null;\n            if (validators) {\n              validators.forEach(function(validator) {\n                error = error || validator(value);\n              });\n            }\n            return error;\n          });\n        },\n\n        onBlur: function(field) {\n          const touched = this.state.touched;\n          touched[field] = true;\n          this.setState({\n            touched: touched\n          });\n        },\n\n        render() {\n          const { data, touched } = this.state;\n          const validators = this.getValidators(data);\n          const errors = this.getErrors(validators, data);\n\n          return (\n            <div className="modal-body">\n              <div className="row">\n                <div className="col-md-12">\n                  <div className={`form-group ${touched[\'text\'] && errors[\'text\'] ? \'has-error\' : \'\'}`}>\n                    <label>\n                      Message\n                    </label>\n                    <textarea\n                      className="form-control"\n                      rows="3"\n                      value={data.text}\n                      placeholder="What\'s happening?"\n                      onChange={(event) => {\n                        this.onChange(\'text\', event.target.value)\n                      }}\n                      onBlur={() => {\n                        this.onBlur(\'text\');\n                      }}\n                    />\n                    {touched[\'text\'] && errors[\'text\'] ? (\n                      <span className="help-block">\n                          {errors[\'text\']}\n                        </span>\n                    ) : null}\n                  </div>\n                </div>\n              </div>\n            </div>\n          );\n        }\n\n      });\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'After...'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import createReactClass from \'create-react-class\';\n      import PropTypes from \'prop-types\';\n      import _ from \'lodash\';\n      import { Field } from \'lore-react-forms\';\n\n      export default createReactClass({\n        displayName: \'FieldExample\',\n\n        getInitialState() {\n          return {\n            data: {\n              text: \'\'\n            }\n          };\n        },\n\n        onChange(name, value) {\n          const nextData = _.merge({}, this.state.data);\n          nextData[name] = value;\n          this.setState({\n            data: nextData\n          });\n        },\n\n        getValidators: function(data) {\n          return {\n            text: [function(value) {\n              if (!value) {\n                return \'This field is required\';\n              }\n            }]\n          };\n        },\n\n        getErrors: function(validatorDictionary, data) {\n          return _.mapValues(data, function(value, key) {\n            const validators = validatorDictionary[key];\n            let error = null;\n            if (validators) {\n              validators.forEach(function(validator) {\n                error = error || validator(value);\n              });\n            }\n            return error;\n          });\n        },\n\n        render() {\n          const { data } = this.state;\n          const validators = this.getValidators(data);\n          const errors = this.getErrors(validators, data);\n\n          return (\n            <div className="modal-body">\n              <div className="row">\n                <div className="col-md-12">\n                  <Field name="text" data={data} errors={errors} onChange={this.onChange}>\n                    {(field) => {\n                      return (\n                        <div className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n                          <label>\n                            Message\n                          </label>\n                          <textarea\n                            className="form-control"\n                            rows="3"\n                            value={field.value}\n                            placeholder="What\'s happening?"\n                            onChange={(event) => {\n                              field.onChange(event, event.target.value)\n                            }}\n                            onBlur={field.onBlur}\n                          />\n                          {field.touched && field.error ? (\n                            <span className="help-block">\n                              {field.error}\n                            </span>\n                          ) : null}\n                        </div>\n                      )\n                    }}\n                  </Field>\n                </div>\n              </div>\n            </div>\n          );\n        }\n\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-components-field-js-2ba382f429a94cfd1a3b.js